import * as React from 'react';

export function useIsMobile(mobileBreakpoint = 768) {
	// Not a `useState` reading `window.innerWidth`: that was a #418 for every mobile visitor and crawler.
	const subscribe = React.useCallback(
		(callback: () => void) => {
			const mql = window.matchMedia(`(max-width: ${mobileBreakpoint - 1}px)`);
			mql.addEventListener('change', callback);
			return () => mql.removeEventListener('change', callback);
		},
		[mobileBreakpoint],
	);

	const getSnapshot = React.useCallback(() => window.innerWidth < mobileBreakpoint, [mobileBreakpoint]);

	return React.useSyncExternalStore(subscribe, getSnapshot, () => false);
}
